import { LIVE_LIBRARIES } from '@disco/constants/FeatureTypes'
import { useFeatureEnabled } from '@disco/state-management/selectors/business'
import { isClientLibrariesTrial } from '@disco/state-management/selectors/user'

import { useSelector } from 'hooks/use-redux'

/**
 * Whether the business can publish client libraries (catalogs and artist
 * profiles): requires the LIVE_LIBRARIES plan feature and no catalogs trial.
 */
export function useLiveLibrariesEnabled(): boolean {
  const clientLibrariesTrial = useSelector(isClientLibrariesTrial)
  return useFeatureEnabled(LIVE_LIBRARIES) && !clientLibrariesTrial
}
